declare global {
	interface Window {
		heap: {
			load: (envId: string, config?: any) => void;
			[key: string]: any;
		};
		heapReadyCb: Array<{
			name: string;
			fn: () => void;
		}>;
	}
}

export const initHeap = () => {
	const envId = process.env.REACT_APP_HEAP_ID || "3221802347"; // production heap id

	window.heapReadyCb = window.heapReadyCb || [];
	window.heap = window.heap || [];

	window.heap.load = (e: string, t: any) => {
		window.heap.envId = e;
		window.heap.clientConfig = t = t || {};
		window.heap.clientConfig.shouldFetchServerConfig = false;

		const a = document.createElement("script");
		a.type = "text/javascript";
		a.async = true;
		a.src = `https://cdn.us.heap-api.com/config/${e}/heap_config.js`;

		const r = document.getElementsByTagName("script")[0];
		r.parentNode?.insertBefore(a, r);

		const n = [
			"init",
			"startTracking",
			"stopTracking",
			"track",
			"resetIdentity",
			"identify",
			"getSessionId",
			"getUserId",
			"getIdentity",
			"addUserProperties",
			"addEventProperties",
			"removeEventProperty",
			"clearEventProperties",
			"addAccountProperties",
			"addAdapter",
			"addTransformer",
			"addTransformerFn",
			"onReady",
			"addPageviewProperties",
			"removePageviewProperty",
			"clearPageviewProperties",
			"trackPageview",
		];

		const i = (e: string) =>
			function () {
				const t = Array.prototype.slice.call(arguments, 0);
				window.heapReadyCb.push({
					name: e,
					fn: () => {
						window.heap[e] && window.heap[e].apply(window.heap, t);
					},
				});
			};

		for (let p = 0; p < n.length; p++) {
			window.heap[n[p]] = i(n[p]);
		}
	};

	// `disableTextCapture` redacts the target text of every captured interaction
	// before it leaves the browser, on every page.
	//
	// 🪤 This is deliberately the GLOBAL option rather than the per-element
	// `data-heap-redact-text` attribute. Heap documents that attribute for the
	// element's own text and does NOT document that it covers descendants — so
	// hanging a ledger table's protection off it would be betting a client's
	// books on undocumented behaviour. The DOM attribute is still applied as a
	// second layer in utils/privacyMask.ts; this is the layer that is certain.
	//
	// What it costs: Heap interactions still record (pageviews, clicks, element
	// selectors), they just no longer carry the on-screen label. The named
	// funnel events do not come from Heap — they go through Segment/GA and now
	// PostHog — so the funnel baseline loses nothing here.
	window.heap.load(envId, { disableTextCapture: true });
};
